import { Component } from 'react';
import PropTypes from 'prop-types';
import I18n from 'I18n';
import unescapedText from 'I18n/utils/unescapedText';
import FormattedMessage from 'I18n/components/FormattedMessage';
import SearchResultRecord from 'SalesContentIndexUI/data/records/SearchResultRecord';
import * as NameCharacterLimit from 'SalesContentIndexUI/constants/NameCharacterLimit';
import { Modal } from 'foundations-components/transitional/components/Modal';
import { DialogBody } from 'foundations-components/transitional/components/DialogBody';
import { DialogFooter } from 'foundations-components/transitional/components/DialogFooter';
import { Button } from 'foundations-components/transitional/components/Button';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { TextInput } from 'foundations-components/transitional/components/TextInput';
import { H2 } from 'foundations-components/transitional/components/H2';
import { DialogHeader } from 'foundations-components/transitional/components/DialogHeader';
import { Form } from 'foundations-components/transitional/components/Form';
import { Select } from 'foundations-components/transitional/components/Select';
import * as folderOptions from '../../utils/folderOptions';
import { FOLDER_CONTENT_TYPES } from 'SalesContentIndexUI/data/constants/FolderContentTypes';
import { DialogCloseButton } from 'foundations-components/transitional/components/DialogCloseButton';

// SalesContentIndexUI does not have an opinion on this type, it is fully controlled by the consumer
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default class CloneModal extends Component {
  constructor(props) {
    super(props);
    this.submit = evt => {
      if (evt) {
        evt.preventDefault();
      }
      const {
        cloneOptions,
        name,
        folderId
      } = this.state;
      const {
        nameIsInvalid
      } = this.validateName();
      if (nameIsInvalid) {
        return null;
      }
      return this.props.onConfirm(Object.assign({
        name,
        folderId
      }, cloneOptions));
    };
    this.updateCloneOptions = updatedCloneOptions => {
      this.setState({
        cloneOptions: Object.assign({}, this.state.cloneOptions, updatedCloneOptions)
      });
    };
    this.handleNameChange = name => {
      this.setState({
        name
      });
    };
    this.validateName = () => {
      const {
        searchResult
      } = this.props;
      const {
        name
      } = this.state;
      const contentType = searchResult.get('contentType');
      const validName = name ?
      // @ts-expect-error contentType may be a folder type based on TypeScript, but we know it's a loose item content type
      name.length > 0 && name.length < NameCharacterLimit[contentType] : false;
      let validationMessage = null;
      if (!name) {
        validationMessage = /*#__PURE__*/_jsx(FormattedMessage, {
          message: `salesContentIndexUI.cloneModal.name.error.${contentType}.noName`
        });
      }

      // @ts-expect-error contentType may be a folder type based on TypeScript, but we know it's a loose item content type
      if (name.length >= NameCharacterLimit[contentType]) {
        validationMessage = /*#__PURE__*/_jsx(FormattedMessage, {
          message: `salesContentIndexUI.cloneModal.name.error.${contentType}.nameTooLong`
        });
      }
      return {
        nameIsInvalid: !validName,
        validationMessage
      };
    };
    this.renderNameControl = ({
      contentType,
      nameIsInvalid,
      validationMessage
    }) => {
      const {
        name
      } = this.state;
      return /*#__PURE__*/_jsx(FormControl, {
        error: nameIsInvalid,
        label: /*#__PURE__*/_jsx(FormattedMessage, {
          message: `salesContentIndexUI.cloneModal.name.label.${contentType}`
        }),
        validationMessage: validationMessage,
        children: /*#__PURE__*/_jsx(TextInput, {
          autoFocus: true,
          defaultValue: name,
          placeholder: I18n.text(`salesContentIndexUI.cloneModal.name.placeholder.${contentType}`),
          onChange: ({
            target: {
              value
            }
          }) => this.handleNameChange(value)
        })
      });
    };
    this.renderFolderControl = ({
      contentType
    }) => {
      const {
        folderContentType
      } = this.props;
      const {
        folderId
      } = this.state;
      if (folderContentType) {
        const onSelectFolder = ({
          target: {
            value
          }
        }) => this.setState({
          folderId: value || null
        });
        const loadOptions = (searchString, callback) => folderOptions.loadFolderOptions(folderContentType, searchString, callback);
        return /*#__PURE__*/_jsx(FormControl, {
          label: /*#__PURE__*/_jsx(FormattedMessage, {
            message: `salesContentIndexUI.cloneModal.folder.label.${contentType}`
          }),
          children: /*#__PURE__*/_jsx(Select, {
            clearable: true,
            loadOptions: loadOptions,
            onChange: onSelectFolder,
            placeholder: I18n.text(`salesContentIndexUI.cloneModal.folder.placeholder.${contentType}`),
            value: folderId
          })
        });
      }
      return null;
    };
    this.renderCloneOptionFields = () => {
      const {
        CloneOptionsComponent
      } = this.props;
      if (CloneOptionsComponent) {
        return /*#__PURE__*/_jsx(CloneOptionsComponent, {
          cloneOptions: this.state.cloneOptions,
          searchResult: this.props.searchResult,
          updateCloneOptions: this.updateCloneOptions
        });
      }
      return null;
    };
    const {
      searchResult: _searchResult
    } = props;
    this.state = {
      cloneOptions: {},
      folderId: _searchResult.get('folderId', null),
      name: unescapedText('salesContentIndexUI.clone', {
        name: _searchResult.get('name')
      })
    };
  }
  render() {
    const {
      searchResult,
      onReject
    } = this.props;
    const contentType = searchResult.get('contentType');
    const {
      nameIsInvalid,
      validationMessage
    } = this.validateName();
    return /*#__PURE__*/_jsx(Modal, {
      size: "auto",
      onEsc: onReject,
      "data-test-id": "clone-content-modal",
      children: /*#__PURE__*/_jsxs(Form, {
        onSubmit: this.submit,
        children: [/*#__PURE__*/_jsxs(DialogHeader, {
          children: [/*#__PURE__*/_jsx(DialogCloseButton, {
            onClick: onReject
          }), /*#__PURE__*/_jsx(H2, {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: `salesContentIndexUI.cloneModal.heading.${contentType}`
            })
          })]
        }), /*#__PURE__*/_jsxs(DialogBody, {
          children: [this.renderNameControl({
            contentType,
            nameIsInvalid,
            validationMessage
          }), this.renderFolderControl({
            contentType
          }), this.renderCloneOptionFields()]
        }), /*#__PURE__*/_jsxs(DialogFooter, {
          children: [/*#__PURE__*/_jsx(Button, {
            disabled: nameIsInvalid,
            "data-selenium-test": "clone-save-button",
            type: "submit",
            use: "primary",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "salesContentIndexUI.cloneModal.save"
            })
          }), /*#__PURE__*/_jsx(Button, {
            use: "tertiary-light",
            onClick: onReject,
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "salesContentIndexUI.cloneModal.cancel"
            })
          })]
        })]
      })
    });
  }
}
CloneModal.propTypes = {
  CloneOptionsComponent: PropTypes.elementType,
  folderContentType: PropTypes.oneOf(FOLDER_CONTENT_TYPES),
  searchResult: PropTypes.instanceOf(SearchResultRecord).isRequired,
  onConfirm: PropTypes.func.isRequired,
  onReject: PropTypes.func.isRequired
};